import { FETCH_PRISMIC, ACTIVE_DOC, PRISMIC_DATA } from '../constants'

const initialState = { prismicCtx: null,  activeDoc: null, prismicData: null }

export default ( state = initialState, action = {}) => {
  switch(action.type) {
    case FETCH_PRISMIC:
      return {
        ...state,
        prismicCtx: action.payload
      }
    case ACTIVE_DOC:
      return {
        ...state,
        activeDoc: action.doc,
      }
    case PRISMIC_DATA:
      return {
        ...state,
        prismicData: action.payload
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/prismicReducer.js